import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import * as queryString from 'query-string'

import { Button, Input } from '../../common'
import { ampSetUserProperty } from '../../../utils/amplitude'
import validateEmail from '../../../utils/validateEmail'
import {
	getFlowTag,
	getFlowType,
	getIsLegalFlow,
	getUserId,
	setEmail,
} from '../../../redux/slices/userSlice'

import './styles.scss'
import { paramsToQuery } from '../../../utils/historyDecorators'
import {
	getInitialPrice,
	getUpsellPrice,
} from '../../../redux/slices/configSlice'

const ENTER_KEYCODE = 13

const Form = ({ setIsActive, checkboxes }) => {
	const dispatch = useDispatch()
	const history = useHistory()
	const params = queryString.parse(location.search)
	const isLegalFlow = useSelector(getIsLegalFlow)
	const flow_type = useSelector(getFlowType)
	const flow_tag = useSelector(getFlowTag)
	const [formValue, setFormValue] = useState('')
	const user_id = useSelector(getUserId)
	const upsell_test = params?.upsell_test || useSelector(getUpsellPrice)
	const initial_price = params?.initial_price || useSelector(getInitialPrice)

	let isValidEmail = checkboxes[0].isChecked && validateEmail(formValue)

	const onSubmitEmail = () => {
		ampSetUserProperty('email', formValue, user_id)
		dispatch(setEmail({ email: formValue }))
		isValidEmail = false

		fetch(`${process.env.REACT_APP_GET_USER_URL}/${formValue}`)
			.then(res => res.json())
			.then(({ premium }) => {
				setIsActive(false)
				if (premium) {
					setTimeout(
						() =>
							history.push({
								pathname: '/success',
								search: isLegalFlow
									? paramsToQuery({
											user_id,
											external_id: user_id,
											billed: true,
									  })
									: paramsToQuery({
											user_id,
											external_id: user_id,
											upsell_test,
											initial_price,
											billed: true,
									  }),
							}),
						350,
					)
				} else {
					setTimeout(() => {
						if (flow_type === '1') {
							history.push({
								pathname: `/sale${flow_tag}-1`,
								search: isLegalFlow
									? paramsToQuery({
											user_id,
											external_id: user_id,
											email: formValue,
									  })
									: paramsToQuery({
											user_id,
											external_id: user_id,
											upsell_test,
											initial_price,
											email: formValue,
									  }),
							})
						} else if (flow_type === '2') {
							history.push({
								pathname: `/sale${flow_tag}-2`,
								search: isLegalFlow
									? paramsToQuery({
											user_id,
											external_id: user_id,
											email: formValue,
									  })
									: paramsToQuery({
											user_id,
											external_id: user_id,
											upsell_test,
											initial_price,
											email: formValue,
									  }),
							})
						} else if (flow_type === '3') {
							history.push({
								pathname: `/sale${flow_tag}-${isLegalFlow ? '3' : '1'}`,
								search: isLegalFlow
									? paramsToQuery({
											user_id,
											external_id: user_id,
											email: formValue,
									  })
									: paramsToQuery({
											user_id,
											external_id: user_id,
											upsell_test,
											initial_price,
											email: formValue,
									  }),
							})
						} else if (flow_type === '4') {
							history.push({
								pathname: `/sale${flow_tag}-${isLegalFlow ? '4' : '2'}`,
								search: isLegalFlow
									? paramsToQuery({
											user_id,
											external_id: user_id,
											email: formValue,
									  })
									: paramsToQuery({
											user_id,
											external_id: user_id,
											upsell_test,
											initial_price,
											email: formValue,
									  }),
							})
						} else if (flow_type === '5') {
							history.push({
								pathname: `/sale${flow_tag}-${isLegalFlow ? '3' : '1'}`,
								search: isLegalFlow
									? paramsToQuery({
											user_id,
											external_id: user_id,
											email: formValue,
									  })
									: paramsToQuery({
											user_id,
											external_id: user_id,
											upsell_test,
											initial_price,
											email: formValue,
									  }),
							})
						} else if (flow_type === '6') {
							history.push({
								pathname: `/sale${flow_tag}-${isLegalFlow ? '4' : '2'}`,
								search: isLegalFlow
									? paramsToQuery({
											user_id,
											external_id: user_id,
											email: formValue,
									  })
									: paramsToQuery({
											user_id,
											external_id: user_id,
											upsell_test,
											initial_price,
											email: formValue,
									  }),
							})
						} else if (flow_type === '9') {
							history.push({
								pathname: `/sale${flow_tag}-${isLegalFlow ? '3' : '1'}`,
								search: isLegalFlow
									? paramsToQuery({
											user_id,
											external_id: user_id,
											email: formValue,
									  })
									: paramsToQuery({
											user_id,
											external_id: user_id,
											upsell_test,
											initial_price,
											email: formValue,
									  }),
							})
						} else if (flow_type === '10') {
							history.push({
								pathname: `/sale${flow_tag}-${isLegalFlow ? '4' : '2'}`,
								search: isLegalFlow
									? paramsToQuery({
											user_id,
											external_id: user_id,
											email: formValue,
									  })
									: paramsToQuery({
											user_id,
											external_id: user_id,
											upsell_test,
											initial_price,
											email: formValue,
									  }),
							})
						}
					}, 350)
				}
			})
	}

	const handleKeyboardSubmitEmail = e => {
		const { keyCode } = e
		if (keyCode === ENTER_KEYCODE && isValidEmail) {
			onSubmitEmail()
		}
	}

	return (
		<div className="email-form-container">
			<h1 className="email-form__title">Email</h1>
			<span className="email-form__tooltip">Photo’s on your way</span>
			<Input
				formValue={formValue}
				setFormValue={setFormValue}
				handleKeyboardSubmitEmail={handleKeyboardSubmitEmail}
			/>
			<Button
				buttonText="Continue"
				onClick={onSubmitEmail}
				disabled={!isValidEmail}
			/>
		</div>
	)
}

export { Form }
